export enum CTALabel {
  Form = "form",
  Instructions = "instructions",
  Teleservice = "teleservice",
  TeleservicePrefill = "teleservicePrefill",
}
